import { cn } from '@bem-react/classname';

export const cnErrorState = cn('ErrorState');
